import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a0f7d470&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=a0f7d470&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f7d470",
  null
  
)

export default component.exports